import tableStore from '../../store/TableStore';
import { WEvent } from './WEvent';

export class WWaitlistSyncEvent extends WEvent {
  id: string;
  waitlistType: string;
  pids: string[];

  constructor(event: WWaitlistSyncEvent) {
    super(event.tableId, event.eventType, event.eventTime);
    Object.assign(this, event);
  }

  applyWebsocketChanges = (): Promise<void> =>
    tableStore.findActiveTableById(this.tableId).then(table => {
      table.setWaitlistCount(this.pids.length);
      table.removeWaitingHostBots(this.pids);
    });
}
